export const ACTIVITY_WORKFLOW_STATUS = {
  DRAFT: 'draft',
  PENDING_REVIEW: 'review',
  APPROVED: 'done',
};

export const ACTIVITY_WORKFLOW_STATUS_COLORS = {
  [ACTIVITY_WORKFLOW_STATUS.DRAFT]: '#414b5c',
  [ACTIVITY_WORKFLOW_STATUS.PENDING_REVIEW]: '#de911d',
  [ACTIVITY_WORKFLOW_STATUS.APPROVED]: '#3b8961',
};
